"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const value = schema_1.Schema.number()
    .unit("%")
    .precision(2)
    .min(0)
    .max(200)
    .interpretation({ vocab: "ltx", code: "hgb_a1_c" })
    .tag({ vocab: "snomed", code: "43396009" })
    .tag({ vocab: "loinc", code: "86910-7" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" });
